import { getEnvironmentConfigs } from '../../../environmentConfigs.ts';
import { generateRandomString, getCodeChallenge } from './cryptoutils.ts';
import { AUTHORIZATION_DETAILS } from './verifyOAuthParams.ts';

type RedirectToAuthorizeParams = {
  instanceUID?: string;
  redirectUri?: string;
  email?: string | null;
};

export function getAuthURL(params?: RedirectToAuthorizeParams) {
  const redirectUri = params?.redirectUri ?? window.location.origin;
  const instanceUID = params?.instanceUID;
  const { apigee, env } = getEnvironmentConfigs();
  const defaultApigeeUrl = `https://${env || 'devint'}.api.openx.com`;
  const AUTH_URL = `${apigee.url || defaultApigeeUrl}/oauth2/v1/authorize`;
  const CODE_VERIFIER = generateRandomString(7);
  const SCOPE = 'openid email profile';
  const STATE = params?.email ? JSON.stringify({ email: params.email }) : 'no-state';
  const NONCE = `nonce-${generateRandomString(6)}`;
  const url = new URL(AUTH_URL);

  url.searchParams.set('scope', SCOPE);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('client_id', apigee.clientId);
  url.searchParams.set('redirect_uri', redirectUri || window.location.origin);
  url.searchParams.set('state', encodeURIComponent(STATE));
  url.searchParams.set('nonce', NONCE);
  url.searchParams.set('code_challenge', getCodeChallenge(CODE_VERIFIER));
  url.searchParams.set('code_challenge_method', 'S256');

  // authorization details
  if (instanceUID) {
    url.searchParams.set(
      AUTHORIZATION_DETAILS,
      JSON.stringify([
        {
          identifier: instanceUID,
          type: 'instance_uid',
        },
      ]),
    );
  }

  return url;
}

export const redirectToAuthorize = (params?: RedirectToAuthorizeParams) => {
  const url = getAuthURL(params);

  window.location.replace(url.toString());
};
